<template>
    <div>
        <Loading  :active="isLoading" :can-cancel="true" :is-full-page="fullPage" />
                 
        <!-- TODO falta poner en lugar el id el nombre de la sección -->
        <Titulo :titulo="seccion.seccion" icono="documento"/>

        <b-container class="contenido">
            <!-- la barra de navegacion -->
            <b-breadcrumb>
                <b-breadcrumb-item href="#home" @click="vuelveRuta(0)">
                    <b-icon icon="house-fill" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                    Home
                </b-breadcrumb-item>
                <b-breadcrumb-item v-for="ruta in rutas" href="#" @click="vuelveRuta(ruta.idDocumento)" :key="ruta.idDocumento">{{ ruta.text }}</b-breadcrumb-item>
            </b-breadcrumb>

            <!-- tabla de documentos -->
            <b-media v-for="(docto, index) in documentos" :key="docto.id_documento">
                <template #aside>
                    <p class="h1">
                        <b-icon class="puntero" :icon="obtieneIcono(index)" @click="cargarCarpeta(index)"></b-icon>
                    </p>
                </template>

                <div v-show="docto.tipo=='D'">{{ docto.documento }}</div>
                <div v-show="docto.tipo=='A'" class="small">Archivo: {{ docto.documento }}</div>
                <div v-show="docto.tipo=='A'" class="small">Tipo: {{ tipoArchivo(index) }} - Tamaño: {{ (docto.tipo == 'D') ? "0": "10Mb" }}</div>
                <div v-show="docto.tipo=='A'" class="small">Fecha de publicación: {{ docto.fecha | fechaMx }}</div>
                <div v-show="docto.tipo=='A'" class="small">Descripción: {{ docto.descripcion }}</div>

                <hr>
            </b-media>
        </b-container>

        <b-modal 
            id="modalDcumento"
            title="Documento"
            size="lg"
            hide-footer
        >
            <b-row class="d-flex justify-content-end mr-1">
                <b-button size="sm" variant="primary" @click="descargarArchivo()">
                    <b-icon-download></b-icon-download> Descargar
                </b-button>
            </b-row>

            <pdf height="400px" :src="documento" />
        </b-modal>

        <b-modal id="modalImagen" title="Documento" size="lg">
            <b-img :src="documento" fluid-grow alt="imagen"></b-img>
        </b-modal>
    </div>


</template>

<script>
import Titulo from '@/components/Titulo.vue'
const axios = require('axios');
import {mapState} from 'vuex'
import pdf from 'vue-pdf'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: 'Documentos',
    filters: {
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        },
        fechaMx: function (fecha) {
            if (fecha != "" && fecha != null) {
                let partesFecha = fecha.split('-');
                let dia = partesFecha[2];
                let mes = partesFecha[1];
                let anio = partesFecha[0];

                return dia+"/"+mes+"/"+anio;
            } else {
                return '';
            }
        }
    },
    props: {
        idSeccion: String,
    },
    components: {
        Titulo, pdf, Loading
    },
    data() {
        return {
            seccion: {},
            dirPadre: 0,
            documentos: [],
            documento: '',  // el documento a mostrar en el modal
            rutas: [],
            rutaActiva: 'active',
            isLoading: true,
            fullPage: true
        }
    },
    created() {
        var formData = new FormData();
        formData.append("accion", "mostrarDatos");
        formData.append("tabla", "secciones");
        formData.append("filtro", `id_seccion=${this.idSeccion}`);
        formData.append("limite", 1);
        
        axios.post(`${this.url}/ajax/ajax.generico.php`, formData)
        .then((res) => {
            if (res.data) {
                this.seccion = res.data

                this.traerDocumentos()
            } else {
                this.seccion = {
                    "seccion": "No se encontró sección"
                }
            }
        });
    },
    mounted() {
        this.isLoading = false;
    },
    methods: {
        traerDocumentos() {
            var formData = new FormData();
            formData.append("accion", "mostrarDatos");
            formData.append("tabla", "documentos");
            formData.append("filtro", `seccion=${this.idSeccion} and dir_padre=${this.dirPadre}`);
            formData.append("ordenamiento", `tipo desc,documento`);
            
            axios
            .post(`${this.url}/ajax/ajax.generico.php`, formData)
            .then((res) => {
                this.documentos = res.data
            });

            this.traterNavegacion(0)
        },
        refrescar() {
            var formData = new FormData();
            formData.append("accion", "mostrarDatos");
            formData.append("tabla", "documentos");
            formData.append("filtro", `seccion=${this.idSeccion} and dir_padre=${this.dirPadre}`);
            formData.append("ordenamiento", `tipo desc,documento`);
            
            axios.post(`${this.url}/ajax/ajax.generico.php`, formData)
            .then((res) => {
                this.documentos = res.data

                this.traterNavegacion(this.dirPadre)
            });
        },
        cargarCarpeta(index) {
            
            // si es de tipo Directorio carga el contenido de la carpeta
            // caso contrario muestra el documento
            if (this.documentos[index].tipo == 'D') {
                this.dirPadre = this.documentos[index].id_documento
    
                this.refrescar()
            } else {
                if (this.tipoArchivo(index) == 'Imagen') {
                    this.documento = this.url + '/doctos/' + this.documentos[index].nombre_interno
                    this.$bvModal.show('modalImagen')
                } else if (this.tipoArchivo(index) == 'PDF'){
                    this.documento = 'api/doctos/' + this.documentos[index].nombre_interno
                    this.$bvModal.show('modalDcumento')
                } else {
                    window.open(`${this.url}/doctos/${this.documentos[index].nombre_interno}`)
                }
            }
        },
        descargarArchivo() {
            window.open(this.documento, 'Download');
        },
        vuelveRuta(dirPadre) {
            if (this.dirPadre != dirPadre) {
                this.dirPadre = dirPadre

                this.refrescar()
            }
        },
        traterNavegacion(dirPadre) {
            var formData = new FormData();
            formData.append('accion', 'traerNavegacion')
            formData.append('seccion', this.idSeccion)
            formData.append('dirPadre', dirPadre)

            axios.post(`${this.url}/ajax/ajax.documentos.php`, formData)
            .then(res => {
                this.rutas = res.data
            });
        },
        obtieneIcono(index) {
            if (this.documentos[index].tipo == 'A') {
                let docto = this.documentos[index].documento

                const iconArray = {
                    "file-text": "txt ini xml xsl ini inf cfg log nfo",
                    "command": "pdf",
                    "file-ppt": "pps ppt pptx",
                    "file-earmark-exce": "xls xlsx",
                    "file-earmark-word": "doc docx",
                    "file-binary": "php php4 php3 phtml phps conf sh shar csh ksh tcl cgi pl js wod app gfm",
                    "file-earmark-image": "jpeg jpe jpg gif png bmp tif tiff",
                    "file-earmark-zip": "zip tar gz tgz z ace rar arj cab bz2",
                    "file-binary": "exe com dll bin dat rpm deb mod",
                    "map": "dxf",
                    "map": "dwg",
                    "map": "dwf"
                }

                var extension = (/[.]/.exec(docto)) ? /[^.]+$/.exec(docto)[0] : "";

                if (extension == "") {
                    return "exclamation";
                }

                var icono = ''
    
                Object.entries(iconArray).forEach(([key, value]) => {
                    value.split(" ").forEach(element => {
                        if (element == extension) {
                            icono = key
                        }
                    })
                })
    
                return icono

            } else {
                return "folder"
            }
        },
        tipoArchivo(index) {
            if (this.documentos[index].tipo == 'A') {
                let docto = this.documentos[index].documento

                const tipoArray = {
                    "Archivo de texto":  "txt ini xml xsl ini inf cfg log nfo",
                    "PDF":  "pdf",
                    "Power point": "pps ppt pptx",
                    "Excel": "xls",
                    "Word": "doc",
                    "Desconocido": "php php4 php3 phtml phps conf sh shar csh ksh tcl cgi pl js wod app gfm",
                    "Imagen": "jpeg jpe jpg gif png bmp tif tiff",
                    "Archivo comprimido": "zip tar gz tgz z ace rar arj cab bz2",
                    "Archivo binario": "exe com dll bin dat rpm deb mod",
                    "DXF": "dxf",
                    "Autocad": "dwg dwf"
                }
    
                var extension = (/[.]/.exec(docto)) ? /[^.]+$/.exec(docto)[0] : "";

                if (extension == "") {
                    return "Desconocido";
                }

                var tipoArchivo = ''
    
                Object.entries(tipoArray).forEach(([key, value]) => {
                    value.split(" ").forEach(element => {
                        if (element == extension) {
                            tipoArchivo = key
                        }
                    })
                })
    
                return tipoArchivo
            }
        }
    },
    computed: {
        url() {
            if ( ["localhost", "127.0.0.1", ""].includes(window.location.hostname) ) {
                return this.urlSandbox
            } else {
                return this.urlProd
            }
        },
        ...mapState(['urlProd']),
        ...mapState(['urlSandbox'])
    }
}
</script>

<style scoped>
.contenido {
    overflow-y: scroll;
    height: 500px;
}

.titulo {
    text-align: center;
}

.puntero {
    cursor: pointer;
}
</style>